module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("成为主播")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  如何成为主播？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("要成为主播，按照要求完善资料，并至少上传3条声音，就能轻松完成认证喔。"), _c('a', {
    attrs: {
      "href": ("" + (_vm.$store.state.ANCHOR_AUTH_URL)),
      "target": "_blank"
    }
  }, [_vm._v("去认证")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  成为主播以后有什么权益呢？")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3. 申请时需要提交哪些资料呢？")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4. 审核时间需要多久？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("审核的周期在3个工作日左右。")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("认证成为主播之后，您能在作品有声化平台内享有以下权益：\n        "), _c('br'), _c('strong', [_vm._v("赚取收益")]), _vm._v("：寻找并参与海选任务，录制完作品后，您能获取录制佣金、作品分成或广告收益；\n        "), _c('br'), _c('strong', [_vm._v("管理任务")]), _vm._v("：在主播工作台里，轻松管理参选任务和播讲作品；\n        "), _c('br'), _c('strong', [_vm._v("数据服务")]), _vm._v("：新增粉丝，收听数据，听众分析，一目了然，尽在掌控之中；\n        "), _c('br'), _c('strong', [_vm._v("Podcast服务")]), _vm._v("：免费的苹果iTunes播客服务，有机会被数亿用户发现；\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("个人认证需要提供真实身份证明。\n        "), _c('br'), _vm._v("机构认证需要提供证明机构身份的真实材料，或运营者身份证明。\n        "), _c('br'), _vm._v("需要微博V认证，或在其他平台有一定粉丝量的名人或企业，可以通过名人名企绿色通道，我们将由专人为您服务。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a80f93b4!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/BeAnAnchor.vue
// module id = 351
// module chunks = 0